var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#696980;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.9,6.37H14.55V5.23a1,1,0,0,0-1-1H11.44a1,1,0,0,0-1,1V6.37H7.1a.94.94,0,0,0,0,1.88h.09L7.89,19a1.69,1.69,0,0,0,1.55,1.79h6.47A1.69,1.69,0,0,0,17.46,19l.7-10.76a.94.94,0,0,0-.26-1.84Zm-8,12.4h0a.57.57,0,0,1-.56-.53l-.45-8.3A.57.57,0,1,1,10,9.88l.45,8.3A.56.56,0,0,1,9.89,18.77Zm2.63,0a.56.56,0,0,1-.56-.55l0-8.31a.58.58,0,0,1,.57-.57.57.57,0,0,1,.56.56l0,8.31A.56.56,0,0,1,12.52,18.77Zm.9-12.64H11.58V5.37h1.84Zm2.34,12.11a.57.57,0,0,1-.57.53h0a.56.56,0,0,1-.54-.59l.4-8.3a.57.57,0,1,1,1.13,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 25,
    height: 25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.2ed8bf4b708cbc2990a9717075e30cf0.svg";
export { ForwardRef as ReactComponent };